import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-school-student-report-daily',

  templateUrl: './school-student-report-daily.component.html',

  styleUrls: ['./school-student-report-daily.component.css']

})

export class SchoolStudentReportDailyComponent implements OnInit {

  showCustom_Map: boolean = false;

  obj_Std: any = {};

  acssess: any;

  lst_Result: any = [];

  lst_Search: any = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(moment().format('jYYYY/jMM/01')),

    strEDate: new FormControl(''),

  })

  mdl_Request: FormGroup = this.FormBuilder.group({

    strAddress: new FormControl(''),

    fLat: new FormControl(0),

    fLon: new FormControl(0),

  });

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    var data = window.localStorage.getItem("menu") as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    this.search_Result();

  }

  async search_Result() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_DailyReports_Search`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Result = res;

    this.lst_Search = res;

  }

  async viewItem(item) {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_DailyReports_Info`, this._otherService.stringNumberToNumber({ ...this.mdl_Search.value, ...item }))).data.toString());

    this._otherService.nonespinner();

    if (res?.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.obj_Std = res[0];

    $("#viewModal").modal('show')

  }

  filter_list(val: any) {

    this.lst_Result = this.lst_Search.filter((el: any) => {

      return el?.strStudentFullName?.includes(val.value) ||

        el?.strFullName?.includes(val.value) ||

        el.strMobileDomain_strComment?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Result = this.lst_Search;

    }

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'گزارش روزانه.xlsx');
  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  accessibility(...array: string[]): boolean {

    let result = false;

    for (let i = 0; i < array.length; i++) {

      if (this.acssess[array[i]] == true && !result) {

        result = true;

        break;

      }

    }

    return result;

  }

  removeItem(item, index) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner()

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iSchool_DailyReports: item.iSchool_DailyReports


            }

            let res = JSON.parse((await axios.post(`School_DailyReports_Delete`, this._otherService.stringNumberToNumber(model))).data.toString());

            this._otherService.nonespinner()

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            else {

              this.lst_Result.splice(index, 1);

              this._tooltip.showSuccess(' با موفقیت حذف شد');

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });
  }

  fullScreen_Image() {

    if (!this.obj_Std.strImage) return;

    const image_Element = $("#fullScreen_");

    image_Element.toggleClass('full-screen');

  }

  open_Location(item) {

    if (item.fLat == 0 || item.fLon == 0) return this._tooltip.showError('مختصاتی یافت نشد')

    Object.keys(item).forEach(key => {

      this.mdl_Request.get(key)?.setValue(item[key])

    });

    this.showCustom_Map = false;

    setTimeout(() => {

      this.showCustom_Map = true;

    }, 10);


  }


}
